export default "__VITE_ASSET__Dqm1uBgv__"